import { AutogenLayoutCheckCallScheduleList } from "./autogen/AutogenLayoutCheckCallScheduleList";

export class CheckCallScheduleList extends AutogenLayoutCheckCallScheduleList {

}
